var firebaseConfig = {
    apiKey: "AIzaSyA8wmspG0reSqiQPbyhhCeQytDTXZSSbcI",
    authDomain: "boi-poka-ff551.firebaseapp.com",
    projectId: "boi-poka-ff551",
    storageBucket: "boi-poka-ff551.appspot.com",
    messagingSenderId: "324404211745",
    appId: "1:324404211745:web:6c81eccddd19337d15b360"
  };

export default firebaseConfig;